import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import FEATURE_FLAG_NAMES from 'platform/utilities/feature-toggles/featureFlagNames';

// Pages whose path moves between the legacy nested contact-info URLs and the
// flat mebNewContactInfoUrls URLs. A returnUrl saved under one flag state is
// invalid under the other (the page's `depends` no longer matches), which
// would otherwise bounce a resuming user back to the start of the form.
const PATH_PAIRS = [{ oldPath: 'phone-and-email', newPath: 'phone-email' }];

// Set by the app's root component so `normalizeReturnUrl` can read the
// latest state when RoutedSavableApp invokes it during the resume cascade.
let storeRef = null;
export const setFormStoreRef = store => {
  storeRef = store;
};
export const resetFormStoreRef = () => {
  storeRef = null;
};

/**
 * `formConfig.normalizeReturnUrl` implementation. Rewrites a saved returnUrl
 * from the old contact-info path to the new one (or vice versa) when the
 * live mebNewContactInfoUrls value no longer matches the path's shape.
 *
 * @param {string} returnUrl - URL from the saved form's metadata
 * @returns {string}
 */
export const normalizeReturnUrl = returnUrl => {
  if (!storeRef || !returnUrl) {
    return returnUrl;
  }

  const [bareUrl, suffix = ''] = returnUrl.split(/([?#].*)$/);
  const hasLeadingSlash = bareUrl.startsWith('/');
  const barePath = bareUrl.replace(/^\/+/, '').replace(/\/+$/, '');

  const mebNewContactInfoUrls = !!toggleValues(storeRef.getState())[
    FEATURE_FLAG_NAMES.mebNewContactInfoUrls
  ];

  const match = PATH_PAIRS.find(({ oldPath, newPath }) =>
    mebNewContactInfoUrls ? barePath === oldPath : barePath === newPath,
  );
  if (!match) {
    return returnUrl;
  }

  const rewrittenPath = mebNewContactInfoUrls ? match.newPath : match.oldPath;
  return `${hasLeadingSlash ? '/' : ''}${rewrittenPath}${suffix}`;
};
